import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Nav: React.FC = () => {
  const location = useLocation();

  const getActiveService = (pathname: string) => {
    if (pathname === '/' || pathname === '/wallet') return 'wallet';
    if (pathname === '/blocks') return 'blocks';
    if (pathname === '/metrics') return 'metrics';
    return 'wallet';
  };

  const activeService = getActiveService(location.pathname);

  return (
    <nav className="service-nav">
      <Link
        to="/wallet"
        className={`nav-link ${activeService === 'wallet' ? 'active' : ''}`}
      >
        Wallet Service
      </Link>
      <Link
        to="/blocks"
        className={`nav-link ${activeService === 'blocks' ? 'active' : ''}`}
      >
        Block Explorer
      </Link>
      <Link
        to="/metrics"
        className={`nav-link ${activeService === 'metrics' ? 'active' : ''}`}
      >
        Metrics
      </Link>
    </nav>
  );
};

export default Nav;
